import { falconClients } from "../clients/falcon.client";

export class AdminActionService {
    async obfuscateUHCBoB(file: File): Promise<Blob> {
        const response = await falconClients.adminActions.obfuscateUHCBoB({
            file,
        });
        //@ts-ignore tsoa says its a string but its a buffer
        const uint8Array = new Uint8Array(response.data);
        const blob = new Blob([uint8Array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        return blob;
    }

    async obfuscateUHCCommSheet(file: File): Promise<Blob> {
        const response = await falconClients.adminActions.obfuscateUHCCommSheet({
            file,
        });
        //@ts-ignore tsoa says its a string but its a buffer
        const uint8Array = new Uint8Array(response.data);
        const blob = new Blob([uint8Array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        return blob;
    }

    async clearDemoTenantData(): Promise<void> {
        return falconClients.adminActions.clearDataFromDemoTenant();
    }
}